// extracted by mini-css-extract-plugin
export default {"videoDiv":"Videos_videoDiv__L286K","inDiv":"Videos_inDiv__5hC7I"};